import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { CheckIcon, palette, Typography } from '@dev/ee-components';

interface CheckWithTextWrapperProps {
    iconSpace: number;
    marginTop: number;
    marginBottom: number;
}

interface CheckWithTextProps {
    iconSize?: number;
    gap?: number;
    marginTop?: number;
    marginBottom?: number;
}
const CheckWithTextWrapper = styled.div.attrs({
    className: 'CheckWithText',
})<CheckWithTextWrapperProps>`
    display: grid;
    grid-template-columns: ${({ iconSpace }) => iconSpace}px auto;
    margin-top: ${({ marginTop }) => marginTop}px;
    margin-bottom: ${({ marginBottom }) => marginBottom}px;
`;

export const CheckWithText = ({
    children,
    iconSize = 20,
    gap = 16,
    marginTop = 16,
    marginBottom = 0,
}: PropsWithChildren<CheckWithTextProps>): JSX.Element => (
    <CheckWithTextWrapper iconSpace={iconSize + gap} marginTop={marginTop} marginBottom={marginBottom}>
        <CheckIcon color={palette.green[5]} width={iconSize} height={iconSize} />
        <Typography variant="body1" bodyVariant="onPaper">
            {children}
        </Typography>
    </CheckWithTextWrapper>
);
